/* Strip trailing slashes from a route path before comparing it.
 *
 * React Router NORMALISES trailing slashes when it MATCHES a route but leaves
 * them on `location.pathname`. So `/portal/` renders the hub — the route
 * matched — while a strict `pathname === '/portal'` test reads false. Anything
 * keyed off that comparison then disagrees with what is actually on screen.
 *
 * That gap was visible in the installed PWA (Anthony, 2026-08-03): at `/portal/`
 * the marketing nav stacked on top of the portal's own header and the shell lost
 * its full-bleed container, because both are driven by one such comparison in
 * App.js.
 *
 * `|| '/'` is load-bearing: a bare "/" would otherwise normalise to the empty
 * string and stop matching the home route.
 */
export function normalizePathname(pathname) {
	if (typeof pathname !== 'string') return '';
	return pathname.replace(/\/+$/, '') || '/';
}

export default normalizePathname;
